import round from 'lodash/round';
import sumBy from 'lodash/sumBy';
import { bool, func } from 'prop-types';
import React, { useEffect } from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import ShareInput from '../../generic/ShareInput';
import { agreementShape } from '../../prop-types';
import { updateQuarterlyBudgets } from './quarterly-budget-helpers';

function AgreementQuarterlySplit({ model, onChange, readOnly }) {
  const { budget, quarterlyBudgets, startDate, endDate } = model;
  const inputProps = { onChange, readOnly };

  useEffect(
    () => {
      if (!onChange) return;

      const updated = updateQuarterlyBudgets(
        quarterlyBudgets,
        startDate,
        endDate,
      );

      if (updated !== quarterlyBudgets) {
        onChange({ target: { name: 'quarterlyBudgets', value: updated } });
      }
    },
    // This effect updates the quarterly budgets, so them changing should not
    // retrigger the effect
    [startDate, endDate, onChange], // eslint-disable-line react-hooks/exhaustive-deps
  );

  const shareSum = sumBy(quarterlyBudgets, 'share');

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Year</th>
          <th>Quarter</th>
          <th>%</th>
          <th>EUR</th>
        </tr>
      </thead>
      <tbody>
        {quarterlyBudgets.map(({ id, year, quarter, share }, index) => (
          <tr key={id || `${year}-${quarter}`}>
            <td>{year}</td>
            <td>{quarter}</td>
            <td>
              <ShareInput
                className="text-nowrap"
                name={`quarterlyBudgets[${index}].share`}
                displayType="input"
                value={share}
                {...inputProps}
              />
            </td>
            <td>
              <CurrencyFormat
                className="text-nowrap"
                name={`quarterlyBudgets[${index}].share`}
                value={round(budget * share, 2)}
                text
                readOnly
              />
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td />
          <td />
          <td>
            <ShareInput
              className="text-nowrap"
              displayType="text"
              value={shareSum}
              readOnly
            />
          </td>
          <td>
            <CurrencyFormat
              className="text-nowrap"
              name="budget"
              value={budget}
              text
              readOnly
            />
          </td>
        </tr>
      </tfoot>
    </table>
  );
}

AgreementQuarterlySplit.propTypes = {
  model: agreementShape.isRequired,
  onChange: func,
  readOnly: bool.isRequired,
};

AgreementQuarterlySplit.defaultProps = {
  onChange: undefined,
};

export default AgreementQuarterlySplit;
